import React from 'react'
import IconBase from 'components/atoms/IconBase/IconBase'

interface Props {
  idVariant?: string
  className?: string
}

function Design({ idVariant = '', className }: Props) {
  return (
    <IconBase name="design" w={20} className={className}>
      <path d="M7.33334 9.12496L9.125 7.31246L7.95834 6.12496L7.04167 7.04162L5.875 5.87496L6.77084 4.95829L5.83334 4.02079L4.02084 5.83329L7.33334 9.12496ZM14.1667 15.9791L15.9792 14.1666L15.0417 13.2291L14.125 14.125L12.9583 12.9583L13.8542 12.0416L12.6667 10.875L10.875 12.6666L14.1667 15.9791ZM6.04167 17.5H2.5V13.9583L6.14584 10.3125L1.66667 5.83329L5.83334 1.66663L10.3333 6.16663L13.4792 2.99996C13.6458 2.83329 13.8333 2.70829 14.0417 2.62496C14.25 2.54163 14.4653 2.49996 14.6875 2.49996C14.9097 2.49996 15.125 2.54163 15.3333 2.62496C15.5417 2.70829 15.7292 2.83329 15.8958 2.99996L17 4.12496C17.1667 4.29163 17.2917 4.47913 17.375 4.68746C17.4583 4.89579 17.5 5.11107 17.5 5.33329C17.5 5.55551 17.4583 5.76746 17.375 5.96913C17.2917 6.17079 17.1667 6.35468 17 6.52079L13.8542 9.68746L18.3333 14.1666L14.1667 18.3333L9.6875 13.8541L6.04167 17.5ZM4.16667 15.8333H5.33334L13.5 7.68746L12.3125 6.49996L4.16667 14.6666V15.8333ZM12.9167 7.10412L12.3125 6.49996L13.5 7.68746L12.9167 7.10412Z" fill="currentColor"/>
    </IconBase>
  )
}

export default Design
